import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { InputBasicSelectInput, InputBasicText } from '../../components/common/Inputs';
import { CountryCode } from '../../config';
import { SiteSurveyAction, RayCodeAction, ProductAction } from '../../actions';
import { RayForm, RayFormValidation } from '../common';
import { useTranslation } from 'react-i18next';
import { Translate as t } from '../../config/Translate';

const SurveyPreviousUnits = ({ name, info, handleChangeDataList, isSummary = false, clist }) => {
	// const [ t, i18n ] = useTranslation();
	const [list, setList] = useState(info || []);
	const [item, setItem] = useState({ brand: "None", product: "" });

	useEffect(() => {
		handleChangeDataList(name, list);
	}, [list]);

	const comboList = [
		{ code: "None", title: "None" },
		{ code: "Carestream", title: "Carestream" },
		{ code: "Gendex", title: "Gendex" },
		{ code: "Planmeca", title: "Planmeca" },
		{ code: "Sirona", title: "Sirona" },
		{ code: "Vatech", title: "Vatech" },
		{ code: "", title: "Other" },
	]
	const handleChangeData = (e) => {
		const { name, value } = e.target;
		setItem({ ...item, [name]: value });
	}
	const Add = () => {
		setList([...list, item]);
		setItem({ brand: "None", product: "" });
	}
	const Del = (idx) => {
		list.splice(idx, 1);
		setList([...list]);
	}
	return (
		<>
			<div className={isSummary ? "" : "section"}>
				{!isSummary && <div className="section-title">{name == 'previousUnitsExtraOral' ? t('product.type.extraOral') : t('product.type.intraOral')}</div>}
				{isSummary && <div className="section-title bdB2">{name == 'previousUnitsExtraOral' ? t('product.type.extraOral') : t('product.type.intraOral')}</div>}
				<div className={isSummary ? "" : "card"}>
					<div className={isSummary ? "" : "card-body"}>
						<ul className="listview simple-listview no-space pb-1">
							{list.map((x, idx) =>
								<li key={idx} className="pt-0">
									{x.brand} / {x.product}
									{!isSummary && <button className="btn btn-sm btn-danger" onClick={() => Del(idx)}>{t('common.button.delete')}</button>}
								</li>
							)}
						</ul>
						<hr className="m-0" />
						{!isSummary && <>
							<InputBasicSelectInput
								options={{ list: comboList, val: item.brand, name: "brand", label: t('product.label.brand') }}
								isForm={!isSummary}
								inline={false}
								editable={!isSummary}
								onchange={handleChangeData} />

							<InputBasicText
								options={{ val: item.product, name: "product", label: t('product.title') }}
								isForm={!isSummary}
								editable={!isSummary}
								onchange={handleChangeData} />
						</>}
						{!isSummary && <button className="btn btn-block btn-primary" onClick={() => Add()}>{t('common.button.add')}</button>}
					</div>
				</div>
			</div>
		</>
	);
}

const SurveyStep2 = ({ Update, info, isSummary = false, gostep, clist }) => {
	// const [ t, i18n ] = useTranslation();
	const [errors, setErrors] = useState([]);
	const [isAddProcess, setIsAddProcess] = useState(false);
	const [siteSurvey, setSiteSurvey] = useState({ ...info, siteSurveyStep: 4 });
	const [category, setCategory] = useState("Delivery");
	const [allModelOptionList, setAllModelOptionList] = useState([]);
	const [models, setModels] = useState([]);
	const [options, setOptions] = useState([]);

	useEffect(() => {
		if (gostep) {
			if (gostep.curStep == 3) {
				let errValidate = [];
				const errValidate1 = RayFormValidation(form_controls1, siteSurvey);
				const errValidate2 = RayFormValidation(form_controls2, siteSurvey);
				errValidate = errValidate.concat(errValidate1);
				errValidate = errValidate.concat(errValidate2);
				if (errValidate.length > 0) {
					setErrors(errValidate);
				} else {
					setIsAddProcess(true);
					Update(siteSurvey._id, { ...siteSurvey, siteSurveyStep: gostep.goStepNo });
				}
			}
		}
	}, [gostep])

	useEffect(() => {
		const list = [];
		allModelOptionList.map(x => {
			if (list.filter(m => m.code == x.group).length == 0)
				list.push({ code: x.group, title: x.group });
		});
		setModels(list)
		setOptionList(siteSurvey.model || "RAYSCAN α+ (NEW)");
	}, [allModelOptionList])

	const setOptionList = (model) => {
		const list = [];
		allModelOptionList.filter(x => x.group == model).map(x => {
			if (list.filter(m => m.code == x.code).length == 0)
				list.push({ code: x.code, title: x.code });
		});
		setOptions(list);
	}

	useEffect(() => {
		setOptionList(siteSurvey.model);
	}, [siteSurvey.model])

	useEffect(() => {
		setAllModelOptionList(clist?.filter(x => x.type === 'PRODUCTOPTION'));
		// RayCodeAction.GetAllByFilter({ type: "PRODUCTOPTION" }).then((e) => {
		// 	setAllModelOptionList(e);
		// });
	}, [clist])

	const handleChangeData = (e) => {
		const { name, value } = e.target;
		setSiteSurvey(prev => ({ ...prev, [name]: value }));
	};

	const Prev = (e) => {
		Update(siteSurvey._id, { ...siteSurvey, siteSurveyStep: 2 });
	};

	const form_controls1 = [
		{
			title: t('service.label.delivery'), items: [
				{ type: "datetime", name: "deliveryDate", label: t('service.field.deliveryDate'), val: siteSurvey.deliveryDate },
				{
					type: "selectinput", name: "accessibility", label: t('common.label.accessibility'), size: 4, val: siteSurvey.accessibility,
					list: [
						{ code: "Main entrance", title: t('installation.label.mainEntrance') },
						{ code: "Secondary enterance", title: t('installation.label.secondaryEntrance') },
						{ code: "Ground floor", title: t('site.label.groundFloor') },
						{ code: "Floor", title: t('site.field.floor') },
						{ code: "", title: t('common.label.other') },
					]
				},
				{
					type: "select", name: "liftYN", label: t('installation.field.lift'), size: 4, val: siteSurvey.liftYN || t('common.label.no'),
					list: [
						{ code: "Yes", title: t('common.label.yes') },
						{ code: "No", title: t('common.label.no') },
					]
				}
			]
		},

		{
			title: t('common.label.dataMigration'), items: [
				{
					type: "select", name: "datamigrationRequired", label: t('common.label.required'), size: 4, val: siteSurvey.datamigrationRequired,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Yes", title: t('common.label.yes') },
						{ code: "No", title: t('common.label.no') },
					]
				},
				{ type: "input", name: "datamigrationModality", label: t('product.field.modality'), size: 4, val: siteSurvey.datamigrationModality },
				{
					type: "select", name: "datamigrationExpense", label: t('service.field.expense'), size: 4, val: siteSurvey.datamigrationExpense,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Yes", title: t('common.label.yes') },
						{ code: "No", title: t('common.label.no') },
					]
				}
			]
		}
	]
	const form_controls2 = [
		{
			title: t('product.type.pms'), items: [
				{ type: "input", name: "integrationPmsBrand", label: t('product.label.brand'), val: siteSurvey.integrationPmsBrand },
				{ type: "input", name: "integrationPmsProduct", label: t('product.title'), val: siteSurvey.integrationPmsProduct },
			]
		},
		{
			title: t('product.type.psp'), items: [
				{ type: "input", name: "integrationPspBrand", label: t('product.label.brand'), val: siteSurvey.integrationPspBrand },
				{ type: "input", name: "integrationPspProduct", label: t('product.title'), val: siteSurvey.integrationPspProduct },
				{
					type: "select", name: "integrationPspTwain", label: t('product.label.twain'), val: siteSurvey.integrationPspTwain,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Yes", title: t('common.label.yes') },
						{ code: "No", title: t('common.label.no') },
					]
				},
			]
		},
		{
			title: t('product.type.intraSensor'), items: [
				{ type: "input", name: "integrationSensorBrand", label: t('product.label.brand'), val: siteSurvey.integrationSensorBrand },
				{ type: "input", name: "integrationSensorProduct", label: t('product.title'), val: siteSurvey.integrationSensorProduct },
				{
					type: "select", name: "integrationSensorTwain", label: t('product.label.twain'), val: siteSurvey.integrationSensorTwain,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Yes", title: t('common.label.yes') },
						{ code: "No", title: t('common.label.no') },
					]
				},
			]
		},
		{
			title: t('product.type.intraCamera'), items: [
				{ type: "input", name: "integrationCameraBrand", label: t('product.label.brand'), val: siteSurvey.integrationCameraBrand },
				{ type: "input", name: "integrationCameraProduct", label: t('product.title'), val: siteSurvey.integrationCameraProduct },
				{
					type: "select", name: "integrationCameraTwain", label: t('product.label.twain'), val: siteSurvey.integrationCameraTwain,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Yes", title: t('common.label.yes') },
						{ code: "No", title: t('common.label.no') },
					]
				},
			]
		},
	]

	const handleChangeDataList = (name, value) => {
		setSiteSurvey(prev => ({ ...prev, [name]: value }));
	}

	const validNext = async () => {
		let errValidate = [];
		const errValidate1 = RayFormValidation(form_controls1, siteSurvey);
		const errValidate2 = RayFormValidation(form_controls2, siteSurvey);
		errValidate = errValidate.concat(errValidate1);
		errValidate = errValidate.concat(errValidate2);
		if (errValidate.length > 0) {
			setErrors(errValidate);
			return;
		}
		setIsAddProcess(true);
		try {
			await Update(siteSurvey._id, siteSurvey);
		} catch (error) {
			console.error('SurveyStep2 validNext error:', error);
		} finally {
			setIsAddProcess(false);
		}
	};

	return (
		<>
			<div className={isSummary ? "" : "section mt-2"}>
				<ul className={isSummary ? "nav nav-tabs style3 mb-1" : "nav nav-tabs style2"}>
					<li className="nav-item">
						<a href
							className={category == "Delivery" ? "nav-link active" : "nav-link"}
							onClick={() => setCategory("Delivery")}>{t('service.label.deliveryInfo')}</a>
					</li>
					<li className="nav-item">
						<a href
							className={category == "PreviousUnits" ? "nav-link active" : "nav-link"}
							onClick={() => setCategory("PreviousUnits")}>{t('installation.field.previousUnit')}</a>
					</li>
					<li className="nav-item">
						<a href
							className={category == "Integration" ? "nav-link active" : "nav-link"}
							onClick={() => setCategory("Integration")}>{t('product.label.integration')}</a>
					</li>
				</ul>
			</div>
			{category == "Delivery" &&
				<RayForm controls={form_controls1} isForm={true} isSummary={isSummary} showAllFields={true} handleChangeData={handleChangeData} errors={errors} />
			}
			{category == "PreviousUnits" &&
				<>
					<SurveyPreviousUnits info={siteSurvey.previousUnitsExtraOral}
						name="previousUnitsExtraOral"
						isSummary={isSummary}
						handleChangeDataList={handleChangeDataList} errors={errors} />
					<SurveyPreviousUnits info={siteSurvey.previousUnitsIntraOral}
						name="previousUnitsIntraOral"
						isSummary={isSummary}
						handleChangeDataList={handleChangeDataList} errors={errors} />
				</>
			}
			{category == "Integration" &&
				<RayForm controls={form_controls2} isForm={true} isSummary={isSummary} showAllFields={true} handleChangeData={handleChangeData} errors={errors} />
			}

			{!isSummary &&
				<div className="section mt-1 mb-2">
					<button className="btn btn-primary btn-block btn-lg" onClick={() => validNext()}>{t('common.button.next')}</button>
					<button className="btn btn-dark btn-block btn-lg mt-1" onClick={() => Prev()}>{t('common.button.back')}</button>
				</div>
			}
		</>
	);
};

const mapState = (state) => {
	const clist = state.RayCodeReducer.items;
	return { clist };
};

const mapDispatch = (dispatch) => ({
	Update: (_id, data) => dispatch(SiteSurveyAction.UpdateSiteSurvey(_id, data)),
});

export default connect(mapState, mapDispatch)(SurveyStep2);